import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class AccordionSection {
	constructor(accordion, index) {
		this.accordion = accordion;
		this.button = accordion.querySelector('.accordion__button');
		this.content = accordion.querySelector('.accordion__content');
		this.icon = accordion.querySelector('.accordion__icon');
		this.line = this.icon.querySelector('.line--scale');
		this._setInitialState();
		this._animation();
		this._eventListener(accordion, index);
	}

	_setInitialState() {
		gsap.set(this.content, {
			height: 'auto',
		});
	}

	_animation() {
		this.animation = gsap
			.timeline()
			.to(this.icon.querySelector('.accordion__icon-vertical-line'), {
				y: '-100%',
                duration: .5,
			})
			.from(
				this.content,
				{
					height: '0',
					duration: 0.5,
					ease: 'power3.inOut',
					autoAlpha: 0,
					y: 50,
					onUpdate: () => {
						ScrollTrigger.refresh();
					},
				},
				0
			)
			.reverse();

		gsap.fromTo(
			this.accordion,
			{
				autoAlpha: 0,
				y: 50,
			},
			{
				duration: 1,
				autoAlpha: 1,
				y: 0,
				delay: 0.5 + 0.5 * this.index,
			}
		);
	}

	_eventListener(accordion, index) {
		if(index == 0 && accordion.parentElement.closest('.faq-block--event')){
			this.animation.reversed ? this.animation.reversed(!this.animation.reversed()) : this.animation.reverse();
		}
		this.button.addEventListener('click', () => {
			this.animation.reversed ? this.animation.reversed(!this.animation.reversed()) : this.animation.reverse();
		});

		if (this.accordion.classList.contains('accordion--open')) {
			// this.animation.reversed ? this.animation.reversed(!this.animation.reversed()) : this.animation.reverse();
		}
	}
}